import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import { validateField } from "../../utils/validation/validation";
import InputField from "../../utils/InputField";
import TextAreaField from "../../utils/TextAreaField";
import Dropzone from "../../utils/dropzone";
import GoogleMapsWrapper from '../../utils/GoogleMapsWrapper';
import PlaceComponent from "../Address/AddressAutoPop";

const LocationForm = React.memo(({ data, onChange, onValidate, errors, isFrom = "page" }) => {
  const handleChange = (field, value) => {
    onChange(field, value);
    const error = validateField(field, value);
    onValidate(field, error);
  };

  const handleFileUpload = (fieldName, uploadedFiles) => {
    console.log("Files uploaded to field:", fieldName, uploadedFiles);
    onChange(fieldName, uploadedFiles);
  };

  return (
    <Container className="px-0" fluid>
      <Row className="no-gutters">
        <Col sm={isFrom === "page" ? 5 : 12}>
          <div className="form-wrapper rounded">
            <Row className="mb-3">
              <div className="form-heading mt-4 mb-4 text-uppercase">Work Location Address</div>
              <GoogleMapsWrapper>
                <PlaceComponent
                  field="address"
                  label="Location Address"
                  className="mb-3"
                  value={data.address}
                  onChange={handleChange}
                  type="text"
                  error={errors.address}
                  controlId="location"
                />
              </GoogleMapsWrapper>
            </Row>
          </div>
        </Col>

        <Col sm={isFrom === "page" ? 7 : 12}>
          <div className="form-wrapper rounded">
            <div className="form-heading mb-4 text-uppercase fw-bold">Project Information</div>
            <Row className="mb-3">
              <InputField
                field="permitType"
                label="Permit Type"
                value={data.permitType}
                onChange={handleChange}
                error={errors.permitType}
                type="select"
                options={["Residential", "Commercial"]}
                as={Col}
                controlId="location"
              />
            </Row>
            <Row className="mb-3">
              <TextAreaField
                field="description"
                label="Description"
                value={data.description}
                onChange={handleChange}
                error={errors.description}
                as={Col}
                controlId="location"
              />
            </Row>
            <Row className="mb-3">
              <InputField
                field="cost"
                label="Cost of Construction"
                value={data.cost}
                onChange={handleChange}
                error={errors.cost}
                as={Col}
                allowCommas={true}
                controlId="location"
              />
            </Row>
          </div>
        </Col>

        <Col sm="12">
          <div className="form-wrapper rounded mt-5">
            <div className="form-heading text-uppercase fw-bold">
              Construction documents, Plans, or Specifications (Only PDF)
            </div>
            <Dropzone fileTypes={["application/pdf"]} showPreview={true} fieldName="locationFiles" onFileUpload={handleFileUpload} />
          </div>
        </Col>
      </Row>
    </Container>
  );
});

export default LocationForm;
